/**
=========================================================
* Otis Admin PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import './i18n';
import "leaflet/dist/leaflet.css";
// Soft UI Context Provider
import { MaterialUIControllerProvider } from "context";
import axios from "axios";

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const isSignIn = window.location.pathname !== "/authentication/sign-in";
    const isInactive =
      status === 403 && err.response?.data?.message === "Account is not active";

    if ((status === 401 || isInactive) && isSignIn) {
      localStorage.removeItem("admin_jwt");
      window.location.href = "/authentication/sign-in";
    }
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
